module.exports = __webpack_public_path__ + "img/ts_calendar2.d66df228.png";